"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCH_BACKOFF_MAX_RETRIES = exports.FETCH_BACKOFF_MAX_WAIT = exports.FETCH_BACKOFF_BASE = void 0;
exports.FETCH_BACKOFF_BASE = 10000; // backoff base starting at 10 seconds
exports.FETCH_BACKOFF_MAX_WAIT = 60000; // don't wait for more than 1 minute
exports.FETCH_BACKOFF_MAX_RETRIES = 10; // max retries
